export default "__VITE_ASSET__DGA5dj_w__"